import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";
import { CustomSignalResistor } from "../../models/signalSources/customSignal.ts";
import { Signal } from "../../models/signal.ts";
import { getSignalLabelFromList } from "../../utils/signalUtils.ts";
import { useResistorOptions } from "../../hooks/useResistorOptions.ts"
import { formatResistorString } from "../../utils/resistor.ts"

interface Props {
  data: CustomSignalResistor;
  onChange: (value: CustomSignalResistor) => void;
  setIsValid: (valid: boolean) => void;
  signalOptions: Signal[];
}

const EditResistorSignalForm: React.FC<Props> = ({ data, onChange, setIsValid, signalOptions }) => {
  const { options } = useResistorOptions();

  const handleChange = (updated: CustomSignalResistor) => {
    onChange(updated);
    updated.name = "Widerstand";
    setIsValid(updated.source_signal.id !== "" && updated.net !== "" && updated.resistance > 0);
  };

  return (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid size={12}>
        <TextField
          select fullWidth label="Quellsignal"
          value={data.source_signal.id}
          error={data.source_signal.id === ""}
          onChange={(e) => {
            const selected = signalOptions.find(s => s.id === e.target.value);
            if (selected) handleChange({ ...data, source_signal: selected });
          }}
        >
          {signalOptions.map(opt => (
            <MenuItem key={opt.id} value={opt.id}>{getSignalLabelFromList(opt.id, signalOptions)}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={12}>
        <TextField 
          fullWidth 
          required 
          label="Signal Name" 
          value={data.net} 
          error={data.net === ""}
          onChange={(e) => handleChange({ ...data, net: e.target.value })}
        />
      </Grid>
      <Grid size={4}>
        <TextField
          select
          fullWidth
          label="Widerstand"
          value={options.includes(data.resistance) ? data.resistance : ""}
          error={data.resistance === 0}
          onChange={(e) =>
            handleChange({
              ...data,
              resistance: parseFloat(e.target.value),
            })
          }
        >
          {(options || []).map((r) => (
            <MenuItem key={r} value={r}> {
              formatResistorString(r)
            }
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={4}>
        <TextField
          select
          fullWidth
          label="Leistung"
          value={data.power}
          onChange={(e) => handleChange({ ...data, power: e.target.value as CustomSignalResistor["power"] })}
        >
          <MenuItem value="0,25W">0,25 W</MenuItem>
          <MenuItem value="0,5W">0,5 W</MenuItem>
        </TextField>
      </Grid>
      <Grid size={4}>
        <TextField
          select
          fullWidth
          label="Toleranz"
          value={data.tolerance}
          onChange={(e) => handleChange({ ...data, tolerance: e.target.value as CustomSignalResistor["tolerance"] })}
        >
          <MenuItem value="1%">1%</MenuItem>
          <MenuItem value="0,5%">0,5%</MenuItem>
          <MenuItem value="0,1%">0,1%</MenuItem>
        </TextField>
      </Grid>
    </Grid>
  );
};

export default EditResistorSignalForm;
